const BOOT_SPLASH_ID = 'boot-splash'

export function hideBootSplash() {
  document.getElementById(BOOT_SPLASH_ID)?.remove()
}
